import { useMemo, useState } from "react";
import { FormControlLabel, Switch } from "@mui/material";

import InstitutionShowStyle from "./style";
import InstitutionTable from "./table";
import { createData } from "./helper";

import { useInstitutionList, useExpiringInstitutions } from "@/api/hooks/institution";

export default function ShowInstitutions() {
    const [showExpiringOnly, setShowExpiringOnly] = useState<boolean>(false);

    const { data: institutions, isLoading: isLoadingAll, isFetching: isFetchingAll } = useInstitutionList();
    const {
        data: expiringInstitutions,
        isLoading: isLoadingExpiring,
        isFetching: isFetchingExpiring,
    } = useExpiringInstitutions();

    const activeData = showExpiringOnly ? expiringInstitutions : institutions;
    const isLoading = showExpiringOnly ? isLoadingExpiring : isLoadingAll;
    const isFetching = showExpiringOnly ? isFetchingExpiring : isFetchingAll;

    const InstitutionData = useMemo(
        () => (activeData ? activeData.data.items.map((item) => createData(item)) : []),
        [activeData]
    );

    return (
        <InstitutionShowStyle>
            <div className="list-header">
                <FormControlLabel
                    control={<Switch checked={showExpiringOnly} onChange={(e) => setShowExpiringOnly(e.target.checked)} />}
                    label="Show expiring only"
                />
            </div>
            <InstitutionTable data={InstitutionData} isFetching={isFetching} isLoading={isLoading} />
        </InstitutionShowStyle>
    );
}
